export default __webpack_public_path__ + "static/logo-f12613217f9a3ca41527cada23be5222.png";